import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PgFormField, PgFormLayout } from '../../../models/form.model';
import { DataService } from '../../../services/data.service';
import { LocalizationService } from '../../../services/localization.service';
import { NotificationsService } from '../../../services/notifications.service';
import { OptionMapsService } from '../../../services/option-maps.service';
import { AuthService } from '../../../services/auth.service';
import { SaveStatusService } from '../../../pg-ui-molecules/save-status.service';
import { EnvironmentService } from '../../../services/environment.service';
import { SingleFormComponent } from '../single-form-main';
import { PGUtilities } from '../../../utilities/pg-utilities';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-forms-article',
    templateUrl: './forms-article.component.html',
    styleUrls: ['./forms-article.component.scss'],
    standalone: false
})
export class FormsArticleComponent extends SingleFormComponent {

    constructor(protected dataService:DataService, protected authService:AuthService, protected localizationService:LocalizationService, protected router:Router, protected route:ActivatedRoute, protected notificationsService:NotificationsService, protected saveStatusService:SaveStatusService, protected optionMapsService:OptionMapsService, protected environmentService:EnvironmentService) {
        super(dataService, authService, localizationService, router, route, notificationsService, saveStatusService, optionMapsService, environmentService)
    }

    resourceId = 'Article';

    formLayout = new PgFormLayout([
        new PgFormField({ label: 'auto', type: 'select', multi: true, name: 'languages', tooltip: 'auto', required: true }),
        new PgFormField({ label: null, type: 'split', name: 'split_0' }),
        new PgFormField({ label: 'auto', type: 'string', name: 'title@ArticleTranslation', locale: true, required: true, maxLength: 100 }),
        //new PgFormField({ label: 'auto', type: 'string', name: 'overtitle@ArticleTranslation', locale: true, required: true, maxLength: 200 }),
        new PgFormField({ label: 'auto', type: 'string', name: 'subtitle@ArticleTranslation', locale: true, required: true, maxLength: 200 }),
        new PgFormField({ label: 'auto', type: 'select', name: 'category', required: true }),
        new PgFormField({ label: 'auto', type: 'select', name: 'secondary_categories', multi: true,
            optionsFilter: [
                { field: 'value', operator: '!=', value: [ '{{$form.category}}' ]}
            ]
        }),
        new PgFormField({ label: 'auto', type: 'string', name: 'tags' }),
        new PgFormField({ label: 'auto', type: 'info', name: 'images_rights', tooltip: 'auto' }),
        new PgFormField({ label: 'auto', type: 'file', name: 'cover', tooltip: 'auto', fileType: 'images', required: true }),
        new PgFormField({ label: 'auto', type: 'file', name: 'images', tooltip: 'auto', multi: true, fileType: 'images' }),
        new PgFormField({ label: 'auto', type: 'file', name: 'videos', multi: true, fileType: 'videos' }),
        new PgFormField({ label: 'auto', type: 'html', name: 'text@ArticleTranslation', locale: true, required: true }),
        new PgFormField({ label: 'auto', type: 'select', name: 'poi_id', 'resource': 'Poi', multi: true, required: true }),
        new PgFormField({ label: 'auto', type: 'location', name: 'geolocation', readonly: true, 
            slaves: {
                'country': 'country',
                'region': 'region',
                'province': 'province',
                'city': 'city',
                'locality': 'locality',
                'address': 'address',
                'zipcode': 'zipcode',
                //'timezone': 'timezone'
            } 
        }),
        new PgFormField({ label: 'auto', type: 'string', name: 'location_description@ArticleTranslation', locale: true }),
        new PgFormField({ label: 'auto', type: 'string', name: 'country', readonly: true }),
        new PgFormField({ label: 'auto', type: 'string', name: 'region', readonly: true }),
        new PgFormField({ label: 'auto', type: 'string', name: 'province', readonly: true }),
        new PgFormField({ label: 'auto', type: 'string', name: 'city', readonly: true }),
        new PgFormField({ label: 'auto', type: 'string', name: 'locality', readonly: true }),
        new PgFormField({ label: 'auto', type: 'string', name: 'address', readonly: true }),
        new PgFormField({ label: 'auto', type: 'string', name: 'zipcode', readonly: true }),
        //new PgFormField({ label: 'auto', type: 'string', name: 'timezone', readonly: true, default: 'Europe/Rome' }),
        new PgFormField({ label: 'auto', type: 'select', name: 'group_id' }),
        new PgFormField({ label: 'auto', type: 'select', name: 'realm_id' }),
        new PgFormField({ label: 'auto', type: 'select', name: 'priority', default: 5, required: true }),
        new PgFormField({ label: 'auto', type: 'json', name: 'paragraphs' }),
        new PgFormField({ label: 'auto', type: 'json', name: 'external_poi' }),
    ]);

    externalPoiFields = [
        new PgFormField({ label: 'auto', type: 'string', name: 'name' }),
        new PgFormField({ label: 'auto', type: 'string', name: 'url' }),
    ]

    paragraphsFields = [
        new PgFormField({ label: 'auto', type: 'string', name: 'title', locale: true, maxLength: 200 }),
        new PgFormField({ label: 'auto', type: 'string', name: 'tags' }),
        new PgFormField({ label: 'auto', type: 'html', name: 'text', locale: true, htmlMode: 'inline-only' }),
        new PgFormField({ label: 'auto', type: 'file', name: 'images', multi: true, fileType: 'images' }),
    ]

    paragraphsLinkFields = [
        new PgFormField({ label: 'auto', type: 'string', name: 'name' }),
        new PgFormField({ label: 'auto', type: 'string', name: 'url' }),
    ]

    protected afterInitializeForm() {
        return new Promise<void>((resolve, reject) => {
            this.formLayout.getFieldLayout('split_0').display = { invisible: true }

            this.formLayout.getFieldLayout('tags').display = { fullWidth: true }

            for(let _field of ['country','region','province','city','locality','address','zipcode'/*,'timezone'*/]) {
                this.formLayout.getFieldByName(_field).visible = false;
            }

            this.formLayout.getFieldByName('priority').visible = false;
            this.formLayout.getFieldByName('paragraphs').visible = false;
            this.formLayout.getFieldByName('external_poi').visible = false;
            this.formLayout.getFieldByName('realm_id').visible = false;

            this.formLayout.getFieldLayout('poi_id').display = { oneLine: true }

            this.formLayout.getFieldLayout('secondary_categories').display = { oneLine: true }
            
            for(let _field of this.paragraphsFields) {
                if(_field.label == 'auto') {
                    _field.label = 'forms-article.paragraphs-field-' + _field.name
                }
            }

            for(let _field of this.paragraphsLinkFields) {
                if(_field.label == 'auto') {
                    _field.label = 'forms-article.paragraphs-links-field-' + _field.name
                }
            }            
    
            for(let _field of this.externalPoiFields) {
                if(_field.label == 'auto') {
                    _field.label = 'forms-article.external-poi-field-' + _field.name
                }
            }

            resolve();
        })
    }

    protected adaptLoadData(values: any) {
        if(values?.poi_id) {
            if(typeof values.poi_id == 'object') {
                values.poi_id = JSON.stringify(values.poi_id)
            }

            if(!/^\[[^\]]*\]$/.test(values.poi_id)) {
                values.poi_id = JSON.stringify([values.poi_id])
            }
        }

        return values;
    }

    protected adaptSaveData(values: any) {
        values = super.adaptSaveData(values);

        if(values.poi_id != null) {
            values.poi_id = JSON.parse(values.poi_id)
        }

        // Migrazione language - languages
        values.language = null;

        return values;
    }

    private _lastPoi = null;
    private _lastPoiSubsription:Subscription = null;

    formLanguages:Array<string> = null;

    paragraphsList:Array<any> = null;

    externalPoiList:Array<any> = null;

    protected async afterLoadData(values:any) {
        this._lastPoi = values?.poi_id;

        this.paragraphsList = PGUtilities.tryParseJSON(values.paragraphs)
        if(this.paragraphsList == null) this.paragraphsList = [];

        for(let _paragraph of this.paragraphsList) {
            if(_paragraph.links == null) _paragraph.links = [];
        }

        this.externalPoiList = PGUtilities.tryParseJSON(values.external_poi)
        if(this.externalPoiList == null) this.externalPoiList = [];

        if(values.language != null) { // Migrazione language - languages
            values.languages = JSON.stringify([values.language])
            for(let _field of this.formLayout.fieldList) {
                if(/@/.test(_field.name)) {
                    let _key = _field.name.replace(/@.*$/, '');
                    
                    let _val:any = {}
                    _val[values.language] = values[_key]

                    values[_field.name] = JSON.stringify(_val)

                    delete values[_key];
                }
            }

            for(let _item of values.paragraphs) {                
                for(let _field of this.paragraphsFields) {
                    if(_field.locale) {
                        let _val:any = {}
                        _val[values.language] = _item[_field.name]
    
                        _item[_field.name] = JSON.stringify(_val)
                    }
                }
            }

            values.language = null;
        }

        this._checkLanguages(values)

        return values;
    }

    beforeValueChanges(values:any, changes:any) {
        if(values.poi_id != this._lastPoi) {
            this._lastPoi = values.poi_id;

            if(this._lastPoiSubsription != null) this._lastPoiSubsription.unsubscribe()

            values.geolocation = null;

            let _poiList = PGUtilities.tryParseJSON(values.poi_id)

            if(_poiList == null || _poiList.length != 1) {
                this.formLayout.setData({ geolocation: { _forceChanges: true } })
            }
            else {
                let _poiId = _poiList[0];

                this._lastPoiSubsription = this.dataService.getResourceData('Poi', { filter: [{ field: 'id', operator: '==', value: [_poiId] }] }).subscribe((data) => {
                    if(data != null && data[0] != null) {
                        let _values = JSON.parse(JSON.stringify({ geolocation: data[0].geolocation }))
                        _values.geolocation._forceChanges = true; // ...e non sono riuscito a risolvere diversamente dal fare questo hack per triggerare la change sul campo
                        this.formLayout.setData(_values)
                    }
                    else {
                        this.formLayout.setData({ geolocation: { _forceChanges: true } })
                    }
                })
            }
        }

        this._checkLanguages(values)

        return values;
    }

    protected async beforeSaveData(values: any) {
        values.paragraphs = await this.remoteTranslateObjectArrayField(this.paragraphsFields, values.languages, values.paragraphs)

        return values;
    }

    private _lastLanguages = null;

    private _checkLanguages(values:any) {
        if(this._lastLanguages != values.languages) {
            this._lastLanguages = values.languages;
            this.formLanguages = PGUtilities.tryParseJSON(values.languages)
        }
        
        if(this.formLanguages == null) this.formLanguages = [];
    }

    onParagraphValueChange() {
        let _val = { paragraphs: JSON.stringify(this.paragraphsList) }
        this.formLayout.setData(_val)
        this.onValueChange(_val)
    }

    addParagraph() {
        this.paragraphsList.push({ links: [] })
        this.onParagraphValueChange();
    }

    deleteParagraph(paragraph:any) {
        let _index = this.paragraphsList.indexOf(paragraph);
        
        if(_index != -1) {
            this.paragraphsList.splice(_index, 1)
            this.onParagraphValueChange();
        }
    }

    moveParagraphPrev(paragraph:any) {
        let _index = this.paragraphsList.indexOf(paragraph);
        
        if(_index != -1 && _index > 0) {
            let _swap = this.paragraphsList[_index];
            this.paragraphsList[_index] = this.paragraphsList[_index - 1];
            this.paragraphsList[_index - 1] = _swap
            this.onParagraphValueChange();
        }
    }

    moveParagraphNext(paragraph:any) {
        let _index = this.paragraphsList.indexOf(paragraph);
        
        if(_index != -1 && _index < this.paragraphsList.length - 1) {
            let _swap = this.paragraphsList[_index];
            this.paragraphsList[_index] = this.paragraphsList[_index + 1];
            this.paragraphsList[_index + 1] = _swap
            this.onParagraphValueChange();
        }
    }

    delParagraphLink(paragraph:any, link:any) {
        let _index = paragraph.links.indexOf(link)

        if(_index != -1) {
            paragraph.links.splice(_index, 1)
            this.onParagraphValueChange();
        }
    }

    addParagraphLink(paragraph:any) {
        paragraph.links.push({})
        this.onParagraphValueChange();
    }
    
    onExternalPoiValueChange() {
        this.formLayout.setData({ external_poi: JSON.stringify(this.externalPoiList) })
    }

    addExternalPoi() {
        this.externalPoiList.push({ })
        this.onExternalPoiValueChange();
    }

    delExternalPoi(poi:any) {
        let _index = this.externalPoiList.indexOf(poi);
        
        if(_index != -1) {
            this.externalPoiList.splice(_index, 1)
            this.onExternalPoiValueChange();
        }
    }

    getRealmId() {
        return this.formLayout.getFieldByName('realm_id').value
    }
}
